import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import NotificationReservationStatus from '@adv-mt/mt-notifications-reservation-status'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {useCardDataInfo} from './components/hooks/useCardDataInfo.js'
import {ReservationCardNewEntryPoint} from './components/reservation-card-new-entry-point.js'
import {RESERVATION_EVENTS_TRACKING, RESERVATION_STATUSES} from './utils/config.js'

const PanelVehicleReservation = ({
  ad,
  financingData,
  seller,
  reservationNewFlow,
  openReservationFaq = false,
  openReservationDrawer = false,
  hitOrigin = 'detail'
}) => {
  const {domain, i18n, user} = useContext(Context)
  const userData = user || {}
  const router = useRouter()

  const {track} = useAnalyticsTrack()
  const cardData = useCardDataInfo(reservationNewFlow.adReservationStatus)

  const hasReservableStatus = reservationNewFlow.adReservationStatus === RESERVATION_STATUSES.RESERVABLE

  const ReservationEntryPoint = ReservationCardNewEntryPoint

  const trackEvent = () =>
    track({
      event: RESERVATION_EVENTS_TRACKING.RESERVATION_INFORMATION_CLICKED,
      data: {
        hit_origin: hitOrigin,
        products: [{id: ad?.id, category: 'ads', price: 0, quantity: 0}]
      }
    })

  const reservationStatusExists = Object.values(RESERVATION_STATUSES).some(
    status => status === reservationNewFlow.adReservationStatus
  )

  const handleManageReservation = async () => {
    const [error, response] = await domain.get('get_messaging_conversation_id_user_use_case').execute({
      entityId: ad?.id,
      buyerId: userData?.userId,
      sellerId: seller?.dealer?.id,
      isProfessionalSeller: seller?.isDealer
    })

    if (error !== null) {
      router.push({
        pathname: '/user/messages'
      })
    }

    router.push({
      pathname: `/user/messages/#/id/${response?.conversationId}`
    })
  }

  return (
    <div className="mt-PanelVehicleReservation">
      {hasReservableStatus ? (
        <ReservationEntryPoint
          ad={ad}
          financingData={financingData}
          dealer={seller?.dealer}
          trackEvent={trackEvent}
          openReservationFaq={openReservationFaq}
          openReservationDrawer={openReservationDrawer}
        />
      ) : (
        <>
          {reservationStatusExists && (
            <div className="mt-PanelVehicleReservation-container">
              <NotificationReservationStatus notificationData={cardData?.notificationInfo} />
              <div className={'mt-PanelVehicleReservation-contentWrapper'}>
                <div>
                  <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xs} title={i18n.t(cardData?.title)} />
                  <p className={'mt-PanelVehicleReservation-titleDescription'}>{i18n.t(cardData?.text)}</p>
                </div>
                {cardData?.hasActionButton && (
                  <AtomButton
                    design={atomButtonDesigns.OUTLINE}
                    fullWidth
                    onClick={handleManageReservation}
                    shape={atomButtonShapes.CIRCULAR}
                  >
                    {i18n.t('RESERVATION_C2B.CARD.BUTTON_TEXT_MANAGE_RESERVATION')}
                  </AtomButton>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

PanelVehicleReservation.displayName = 'PanelVehicleReservation'
PanelVehicleReservation.propTypes = {
  ad: PropTypes.object,
  financingData: PropTypes.object,
  seller: PropTypes.object,
  reservationNewFlow: PropTypes.object,
  openReservationFaq: PropTypes.bool,
  openReservationDrawer: PropTypes.bool,
  hitOrigin: PropTypes.string
}

export {ModalCardVehicle} from './components/reservation-modal-card-vehicle.js'
export {CardAdSkeleton} from './components/cardAdSkeleton.js'

export default PanelVehicleReservation
